/**
 * created by lei lei on 2020/6/23
 * 我的媒体的action
 */
import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName();
let headers = {
    "Content-Type": 'application/json;charset=UTF-8'
};
let cacheAndcredentials = {cache: 'no-cache', /*credentials: 'include'*/}
host = '/cm-sites-media-matrix-service/';
let hostContribute='/cm-sites-contribute/';
//host = 'http://192.168.220.6:7898/cm-sites-media-matrix-service/';
hostContribute="/cm-sites-" + applicationName()+'/';
const Apis = {
    getMediaList: host + 'media/getMediaListByDepts',//获取媒体列表
    getMediaIsOAuth: host + 'media/isOAuth',//获取媒体类型
    gotoOAuth: hostContribute + 'media/gotoOAuth',//去认证
    mediaAdd: hostContribute + 'media/add',//新增接口
    addUserMedia: host + 'media/addUserMedia',//设置用户所属媒体
    getIsMediaByName: hostContribute + 'media/isMediaByName/',//检测媒体是否已存在
    mediarecord: host + 'mediarecord/',//新增媒体备案
    allMedia: host + 'mediarecord/all/',//获取申请列表
    mediarecordExportExcel: host + 'mediarecord/excel/',//导出表格
    mediaStatistics: host + 'media/statistics',//我的媒体发文数统计
    getDeptAndSon: host + 'dept/getDeptAndSon',//获取添加备案的部门
    isOAuthSuccess: hostContribute + 'media/isOAuthSuccess',//获取是否认证
    updateMediaAuthenticationStatus: host + 'media/updateMediaAuthenticationStatus',//更新认证状态
    delMediaById: hostContribute + 'media/delMediaById',//删除媒体



    deptAll: host + 'dept/listBy',//获取用户管理的部门
    getUserList: hostContribute + 'user/list/',//用户列表
    listBy: hostContribute + 'user/listBy',//用户列表

    addUser: hostContribute + 'user/add',//添加用户
    editUser: hostContribute + 'user/newUpdateUserInfo',//编辑用户
    ableUser: hostContribute + 'user/disableUser',//解禁用户
    delUser: hostContribute + 'user/delUser',//删除用户

    newMediaAuthenticationStatus: hostContribute + 'media/newMediaAuthenticationStatus',//获取授权过期数据
    updateNewMediaAuthenticationStatus: hostContribute + 'media/updateNewMediaAuthenticationStatus',//获取授权过期数据

};

//获取媒体列表
export function getMediaList(deptIds, callBack) {
    let url = Apis.getMediaList + '?isSecondary=true&deptIds=' + deptIds;
    request({url, callBack});
}

//获取媒体类型
export function getMediaType(id, callBack) {
    let url = Apis.getMediaIsOAuth + '?id=' + id;
    request({url, callBack});
}

//媒体去认证
export function gotoOAuth(id, callBack) {
    let url = Apis.gotoOAuth + '?id=' + id;
    request({url, callBack});
}


//检测媒体名称是否已存在
export function getIsMediaByName(mediaName, callBack) {
    let url = Apis.getIsMediaByName + '?name=' + mediaName;
    request({url, callBack});
}

//新增备案
export function addMediaRecord(body, callBack) {
    let url = Apis.mediarecord;
    request({url, body, method:"post", callBack});
}

//新增媒体
export function addMedia(body, userAccount, mediaCodes,recordId, callBack) {
    let url = Apis.mediaAdd + '?userAccount=' + userAccount + '&mediaCodes=' + mediaCodes+'&recordId='+recordId;
    request({url, body, method:"post", callBack});
}

//设置用户所属媒体
export function addUserMedia(body, callBack) {
    let url = Apis.addUserMedia;
    request({url, body, method:"post", callBack});
}

//获取我的申请列表
export function getAllMedia(account, callBack) {
    let url = Apis.allMedia + account;
    request({url, callBack});
}

//导出媒体表格
export function exportMedia(account, callBack) {
    let url = Apis.mediarecordExportExcel + account;
    callBack(url);
}

//获取发文数数据统计
export function getMediaStatistics(codes,callBack) {
    let url = Apis.mediaStatistics+'?mediaCodes='+codes;
    request({url, callBack});
}

//获取备案部门
export function getDeptAndSon(body,callBack) {
    let url = Apis.getDeptAndSon;
    request({url, body, method:"post", callBack});
}

//获取用户管理的所有的部门名称目前不使用了。
export function allDepart(id, callBack) {
    let url = Apis.deptAll + '?id=' + id;
    request({url, callBack});
}

//获取用户管理列表
export function getAllUser(account, callBack) {
    let url = Apis.listBy +'?createBy='+ account;
    request({url, callBack});
}


//添加用户
export function addUser(body, callBack) {
    let url = Apis.addUser;
    request({url, method:"post", body, callBack});
}

//编辑用户
export function editUser(body, callBack) {
    let url = Apis.editUser;
    request({url, body, callBack});
}

//解禁用户
export function ableUser(body, callBack) {
    let url = Apis.ableUser;
    request({url, body, callBack});
}

//删除用户
export function delUser(body, callBack) {
    let url = Apis.delUser;
    request({url, body, callBack});
}
//获取认证状态
export function isOAuthSuccess(body, callBack) {
    let url = Apis.isOAuthSuccess;
    request({url, body, callBack});
}
//更新认证状态
export function updateMediaAuthenticationStatus(body, callBack) {
    let url = Apis.updateMediaAuthenticationStatus;
    request({url, body, callBack});
}

//删除媒体
export function delMediaById(body, callBack) {
    let url = Apis.delMediaById;
    request({url, body, callBack});
}

//获取授权过期数据
export const newMediaAuthenticationStatus = (body, callBack) => {  //获取授权过期数据
    request({url:Apis.newMediaAuthenticationStatus, body, callBack});
};

//更新授权状态
export const updateNewMediaAuthenticationStatus = (body, callBack) => {  //获取授权过期数据
    request({url:Apis.updateNewMediaAuthenticationStatus, body, callBack});
};